import React from 'react';
import Link from 'next/link';
import { IoArrowUndo } from 'react-icons/io5';
import NextImage from '@/features/Image';

const BlogComments = () => {
  return (
    <>
      <div
        className="blog-details__comment"
        data-aos="fade-up"
        data-aos-duration={1000}
      >
        <div className="sidebar">
          <div className="sidebar__comment">
            <div className="sidebar__head">
              <h3>Comment</h3>
            </div>
            <div className="sidebar__comment-body">
              <ul>
                <li className="sidebar__comment-item">
                  <div className="comment">
                    <div className="comment__inner">
                      <div className="comment__head">
                        <div className="comment__author">
                          <div className="comment__author-thumb">
                            <NextImage
                              width={49}
                              height={48}
                              src="/images/blog/user/3.png"
                              alt="comment-author"
                            />
                          </div>
                          <div className="comment__author-info">
                            <h6 className="mb-0">Mark Johnson</h6>
                            <span>March 12, 2024</span>
                          </div>
                        </div>
                        <div className="comment__action">
                          <Link href="#post">
                            {' '}
                            <span>
                              <IoArrowUndo />
                            </span>
                            reply
                          </Link>
                        </div>
                      </div>
                      <div className="comment__body">
                        <div className="comment__body-inner">
                          <p className="mb-0">
                            We invite you to explore our trading blog for the
                            latest industry insights and expert analysis and
                            make decisions.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
                <li className="sidebar__comment-item sidebar__comment-item--reply">
                  <div className="comment">
                    <div className="comment__inner">
                      <div className="comment__head">
                        <div className="comment__author">
                          <div className="comment__author-thumb">
                            <NextImage
                              width={49}
                              height={48}
                              src="/images/blog/user/3.png"
                              alt="comment-author"
                            />
                          </div>
                          <div className="comment__author-info">
                            <h6 className="mb-0">Tommy Reed</h6>
                            <span>April 02, 2024</span>
                          </div>
                        </div>
                        <div className="comment__action">
                          <Link href="#post">
                            {' '}
                            <span>
                              <IoArrowUndo />
                            </span>
                            reply
                          </Link>
                        </div>
                      </div>
                      <div className="comment__body">
                        <div className="comment__body-inner">
                          <p className="mb-0">
                            Absolutely! Delving into your trading blog for
                            invaluable insights. Staying informed for smarter
                            decisions.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
                <li className="sidebar__comment-item sidebar__comment-item--reply">
                  <div className="comment">
                    <div className="comment__inner">
                      <div className="comment__head">
                        <div className="comment__author">
                          <div className="comment__author-thumb">
                            <NextImage
                              width={49}
                              height={48}
                              src="/images/blog/user/3.png"
                              alt="comment-author"
                            />
                          </div>
                          <div className="comment__author-info">
                            <h6 className="mb-0">Max Adams.</h6>
                            <span>April 16, 2024</span>
                          </div>
                        </div>
                        <div className="comment__action">
                          <Link href="#post">
                            {' '}
                            <span>
                              <IoArrowUndo />
                            </span>
                            reply
                          </Link>
                        </div>
                      </div>
                      <div className="comment__body">
                        <div className="comment__body-inner">
                          <p className="mb-0">
                            Staying informed for smarter decisions. Grateful for
                            the expert analysis you provide.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
                <li className="sidebar__comment-item">
                  <div className="comment">
                    <div className="comment__inner">
                      <div className="comment__head">
                        <div className="comment__author">
                          <div className="comment__author-thumb">
                            <NextImage
                              width={49}
                              height={48}
                              src="/images/blog/user/3.png"
                              alt="comment-author"
                            />
                          </div>
                          <div className="comment__author-info">
                            <h6 className="mb-0">Chris Scott</h6>
                            <span>May 20, 2024</span>
                          </div>
                        </div>
                        <div className="comment__action">
                          <Link href="#post">
                            {' '}
                            <span>
                              <IoArrowUndo />
                            </span>
                            reply
                          </Link>
                        </div>
                      </div>
                      <div className="comment__body">
                        <div className="comment__body-inner">
                          <p className="mb-0">
                            Delving into your trading blog for invaluable
                            insights. Staying informed for smarter decisions.
                            Stay informed and make informed decisions.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BlogComments;
